module.exports = __webpack_public_path__ + "img/intro4.e2cb67dd.png";